import React from "react";
import PropTypes from "prop-types";

export default function GymCard({ gymInfo, manageTrack, leaveGym }) {
  return (
    <tr>
      <td>{gymInfo.Name}</td>
      <td>Athlete</td>
      <td>
        <i className="mdi mdi-thumb-up senaryColor"></i>
      </td>
      <td className={`pointerCursor`}>
        <a onClick={() => manageTrack(gymInfo)} className="linkStyles">
          Manage
        </a>
        {" | "}
        <a onClick={() => leaveGym(gymInfo)} className="linkStyles">
          Remove
        </a>
      </td>
    </tr>
  );
}

GymCard.propTypes = {
  gymInfo: PropTypes.object,
  manageTrack: PropTypes.func,
  leaveGym: PropTypes.func,
};
